export const LOAD_RECAPTCHA_MAX_ATTEMPTS = 5;
export const LOAD_RECAPTCHA_TIMEOUT = 2000;
